import React from "react";
import { EVENTS } from "../lib/brand";

export default function Marquee() {
  const doubled = [...EVENTS, ...EVENTS];
  return (
    <section
      data-testid="events-marquee"
      className="relative overflow-hidden border-y border-[#27272A] bg-[#0a0a0a] py-5"
    >
      <div className="kf-stripe absolute inset-0 opacity-60" />
      <div className="relative flex w-[200%] animate-marquee gap-12 whitespace-nowrap">
        {doubled.map((ev, i) => (
          <div
            key={i}
            className="font-display text-xl uppercase tracking-[0.3em] text-[#F5F5DC]"
          >
            {ev} <span className="ml-12 text-[#E11D2A]">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
